/**
 * @file Discover Album Folder Summary view.
 */

import React from 'react';

import DiscoverAlbumFolderSummaryContainer from '../../containers/discover/DiscoverAlbumFolderSummaryContainer';

const DiscoverAlbumFolderSummaryView = props => (
  <DiscoverAlbumFolderSummaryContainer {...props} />
);

export default DiscoverAlbumFolderSummaryView;
